export class ProductOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['option', 'selected-variant']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'change', this.onProductOptionChange.bind(this))

    for (const option of this.els.option.elements) {
      this.listeners.add(
        option,
        'mouseenter',
        this.onProductOptionEnter.bind(this),
      )
      this.listeners.add(
        option,
        'mouseleave',
        this.onProductOptionLeave.bind(this),
      )
    }
  }

  onProductOptionChange (event) {
    const target =
      event.target.tagName === 'SELECT'
        ? event.target.selectedOptions[0]
        : event.target

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_SELECTED, {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  onProductOptionEnter (event) {
    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_ENTERED, {
      event,
      selectedOptionValues: this.selectedOptionValues,
    })

    const threshold = Number(this.els.availability?.element?.dataset.threshold)
    const target = event.target.closest('[data-product-options-el="option"]')

    if (threshold) {
      if (Number(target.dataset.stock) <= threshold) {
        if (Number(target.dataset.stock) === 0) {
          this.els.availability.element.innerText = `${window.theme.strings.productStrings.notifyMe}`
        } else {
          this.els.availability.element.innerText = `${window.theme.strings.productStrings.lowAvailability}`
        }
      } else {
        this.els.availability.element.innerText = ''
      }
    }
  }

  onProductOptionLeave () {
    if (this.els.availability?.element) {
      this.els.availability.element.innerText = ''
    }
  }

  get selectedOptionValues () {
    const selectedOptions = Array.from(this.querySelectorAll('select')).flatMap(
      (select) =>
        Array.from(select.selectedOptions).map(
          (option) => option.dataset.optionValueId,
        ),
    )

    const checkedInputs = Array.from(
      this.querySelectorAll('fieldset input:checked'),
    ).map((input) => input.dataset.optionValueId)

    return [...selectedOptions, ...checkedInputs]
  }

  get selectedVariant () {
    return JSON.parse(this.els['selected-variant'].element.innerHTML)
  }
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions)
}
